module.exports = __webpack_public_path__ + "img/security-audit-img-3.5bec7953.webp";